import { render, staticRenderFns } from "./MenuLinkAction.vue?vue&type=template&id=809e9f4e"
import script from "./MenuLinkAction.vue?vue&type=script&lang=js"
export * from "./MenuLinkAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports